import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-grid-sharp",
  "use": "icon-grid-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-grid-sharp\"><title>Grid</title><path d=\"M240 240H32V32h208zM480 240H272V32h208zM240 480H32V272h208zM480 480H272V272h208z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol